import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deactivateCard: {
    id: 'deactivateCard',
    defaultMessage: 'Deactivate Card',
    description: 'A CTA to allow users to deactivate their loyalty card.',
  },
  closeWindow: {
    id: 'closeWindow',
    defaultMessage: 'Close Window',
    description: 'A CTA to allow the user to close the window after successful card deactivation.',
  },
  deactivateTimsCard: {
    id: 'deactivateTimsCard',
    defaultMessage: 'Deactivate a Tims Rewards Card',
    description: 'A heading for the modal which allows users to deactivate their rewards card.',
  },
  timsCardLostOrStolen: {
    id: 'timsCardLostOrStolen',
    defaultMessage:
      "If your Tims Rewards card is lost or stolen, you can deactivate it and remove it from your account. You'll receive a new digital card so you can continue earning. {linebreak} Don't worry, all your transactions and rewards will be saved to your account.",
    description:
      'A note to the user on what should be done if their rewards card is lost or stolen.',
  },
  chatWithUs: {
    id: 'chatWithUs',
    defaultMessage: 'chat with us',
    description: 'A note prompting the user to contact support if needed.',
  },
  cardDeactivationError: {
    id: 'cardDeactivationError',
    defaultMessage:
      'We were unable to process your request. Please try again or {link} for assistance.',
    description: 'An error message to let the user know that card deactivation failed.',
  },
  successfulCardDeactivation: {
    id: 'successfulCardDeactivation',
    defaultMessage: 'Your card was successfully deactivated and your digital card has been updated',
    description: 'A note to the user that card deactivation was successful.',
  },
  success: {
    id: 'success',
    defaultMessage: 'Success',
    description: 'A heading which shows when card deactivation was successful.',
  },
});
